module.exports = __webpack_public_path__ + "img/img-ready-03.4c3d7ccb.png";